import React from "react";
import { TableHeader } from "./TableHeader";
import { InvoiceTableRow } from "./InvoiceTableRow";
import { EmptyState } from "./EmptyState";

export const InvoiceTable = ({ invoices, isDownloading, downloadingInvoiceId, onDownload, onPay }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm text-left border-collapse">
      <TableHeader />
      <tbody className="divide-y divide-gray-100 dark:divide-gray-700/50">
        {invoices.map((invoice) => (
          <InvoiceTableRow
            key={invoice.id}
            invoice={invoice}
            isDownloading={isDownloading}
            downloadingInvoiceId={downloadingInvoiceId}
            onDownload={onDownload}
            onPay={onPay}
          />
        ))}
      </tbody>
    </table>
    {invoices.length === 0 && <EmptyState />}
  </div>
);
